import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

const S = {
  Wrapper: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 30px;
    padding: 4px 8px;
    border-top: 1px solid ${({ theme }) => theme.palette.grey[300]};
    font-size: ${({ theme }) => theme.typography.pxToRem(13)};
    background-color: ${({ theme }) => theme.palette.grey[100]};
  `,
  PageNumber: styled.p`
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-right: auto;
    color: ${({ theme }) => theme.palette.grey[700]};
  `,
  PageValue: styled.data`
    margin-right: 4px;
  `,
};

const IndividualViewportFooter = ({ pageNumber, numPages }) => (
  <S.Wrapper>
    <S.PageNumber>
      <FormattedMessage
        {...messages.individualViewportFooterPageNumber}
        values={{
          page: (
            <S.PageValue value={pageNumber}>
              {`${pageNumber}/${numPages}`}
            </S.PageValue>
          ),
        }}
      />
    </S.PageNumber>
  </S.Wrapper>
);

IndividualViewportFooter.propTypes = {
  numPages: PropTypes.number,
  pageNumber: PropTypes.number,
};

IndividualViewportFooter.defaultProps = {
  numPages: 0,
  pageNumber: 1,
};

export default memo(IndividualViewportFooter);
